var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{attrs:{"for":"typeSelect"}},[_vm._v("Filter by data type")]),_c('b-form-select',{attrs:{"id":"typSelect","options":_vm.options,"size":"sm"},on:{"input":_vm.emitInput,"change":_vm.emitChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }